<!-- 洗车指南 -->
<template>
  <div class="car-guide" v-cloak>
    <van-nav-bar :border="false" left-arrow fixed title="洗车指南" class="car_guide_nav_bar" @click-left="onClickLeft" :z-index="20" :style="'background: #2998FF; color:#FFFFFF;'"></van-nav-bar>

    <div class="header-b">
      <img src="../../assets/car-guide/header-bg.png" alt="">
    </div>

    <!-- 1 -->
    <div class="center-block">
      <div class="top-block" @click="isShow = !isShow">
        <div class="top-icon">
          <img src="../../assets/car-guide/l_icon.png" alt="">
          <span v-if="article_list[0]">{{article_list[0].title}}</span>
        </div>
        <div class="right-icon">
          <img v-show="isShow" src="../../assets/car-guide/s_icon.png" alt="">
          <img v-show="!isShow" src="../../assets/car-guide/x_icon.png" alt="">
        </div>
      </div>
      <div v-show="isShow" class="foot-block">
        <div v-if="article_list[0]" v-html="article_list[0].content"></div>
      </div>
    </div>
    <!-- 会员充值 -->
    <div class="center-block">
      <div class="top-block" @click="isShow1 = !isShow1">
        <div class="top-icon">
          <img src="../../assets/car-guide/l_icon.png" alt="">
          <span v-if="article_list[1]">{{article_list[1].title}}</span>
        </div>
        <div class="right-icon">
          <img v-show="isShow1" src="../../assets/car-guide/s_icon.png" alt="">
          <img v-show="!isShow1" src="../../assets/car-guide/x_icon.png" alt="">
        </div>
      </div>
      <div v-show="isShow1" class="foot-block">
        <div v-if="article_list[1]" v-html="article_list[1].content"></div>
      </div>
    </div>
    <!-- 洗车流程 -->
    <div class="center-block">
      <div class="top-block" @click="isShow2 = !isShow2">
        <div class="top-icon">
          <img src="../../assets/car-guide/l_icon.png" alt="">
          <span v-if="article_list[2]">{{article_list[2].title}}</span>
        </div>
        <div class="right-icon">
          <img v-show="isShow2" src="../../assets/car-guide/s_icon.png" alt="">
          <img v-show="!isShow2" src="../../assets/car-guide/x_icon.png" alt="">
        </div>
      </div>
      <div v-show="isShow2" class="foot-block">
        <div v-if="article_list[2]" v-html="article_list[2].content"></div>
      </div>
    </div>
    <!-- 注意事项 -->
    <div class="center-block">
      <div class="top-block" @click="isShow3 = !isShow3">
        <div class="top-icon">
          <img src="../../assets/car-guide/l_icon.png" alt="">
          <span v-if="article_list[3]">{{article_list[3].title}}</span>
        </div>
        <div class="right-icon">
          <img v-show="isShow3" src="../../assets/car-guide/s_icon.png" alt="">
          <img v-show="!isShow3" src="../../assets/car-guide/x_icon.png" alt="">
        </div>
      </div>
      <div v-show="isShow3" class="foot-block">
        <div v-if="article_list[3]" v-html="article_list[3].content"></div>
      </div>
    </div>
    <!-- 教学视频 -->
    <div class="center-block">
      <div class="top-block" @click="isShow4 = !isShow4">
        <div class="top-icon">
          <img src="../../assets/car-guide/l_icon.png" alt="">
          <span v-if="article_list[4]">{{article_list[4].title}}</span>
        </div>
        <div class="right-icon">
          <img v-show="isShow4" src="../../assets/car-guide/s_icon.png" alt="">
          <img v-show="!isShow4" src="../../assets/car-guide/x_icon.png" alt="">
        </div>
      </div>
      <div v-show="isShow4" class="foot-block">
        <div v-if="article_list[4]" v-html="article_list[4].content"></div>
        <!-- <video controls="controls" width='100%' height='100%' id="player" allowscriptaccess="always" src="../../assets/video/jxsp.mp4" type="video/x-ms-asf-plugin" autostart="true"></video> -->
      </div>
    </div>

  </div>
</template>

<script type="text/babel"> 
import wx from "weixin-js-sdk";
export default {
  name: "car-guide",
  components: {   },
  props: {},
  data() {
    return {
      isShow: false,
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
      article_list: [],
    };
  },
  watch: {},
  created() {},
  mounted() {
    // this.$toast.loading();
    this.getInit();
  },
  methods: {
    getInit() {
      let _this = this;
      let data = {
        cate_id: 18,
      };
      _this.$post("/api/get_article_list", data, data).then((res) => {
        console.log(res.data, "洗车指南");
        // this.$toast.clear();
        if (res.data && res.data.code == 0) {
          // this.article_list = res.data.data;
          this.article_list = res.data.data.map((item, index) => ({
            content: _this.formatRichText(item.content),
            id: item.id,
            title: item.title,
          }));

          // this.document.content = this.formatRichText(res.data.data.content);
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },

    formatRichText(html) {
      /*
       * 处理富文本里的图片宽度自适应
       * 1.去掉img标签里的style、width、height属性
       * 2.img标签添加style属性：max-width:100%;height:auto
       * 3.修改所有style里的width属性为max-width:100%
       * 4.去掉<br/>标签
       * @param html
       * @returns {void|string|*}
       */
      let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match
          .replace(/style="[^"]+"/gi, "")
          .replace(/style='[^']+'/gi, "");
        match = match
          .replace(/width="[^"]+"/gi, "")
          .replace(/width='[^']+'/gi, "");
        match = match
          .replace(/height="[^"]+"/gi, "")
          .replace(/height='[^']+'/gi, "");
        // match = match
        //   .replace(/src="([^"]+)"/gi, 'src="http://xiche.yiro.top$1"')
        //   .replace(/src='([^']+)'/gi, 'src="http://xiche.yiro.top$1"');
        return match;
      });
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/width:[^;]+;/gi, "max-width:100%;")
            .replace(/width:[^;]+;/gi, "max-width:100%;");
          return match;
        }
      );
      // newContent = newContent.replace(/<br[^>]*\/>/gi, '');
      newContent = newContent.replace(
        /\<img/gi,
        '<img style="max-width:100%;height:auto;display:inline-block;"'
      );

      //去除table的宽度
      newContent = newContent.replace(
        /<table[^>]*>/gi,
        function (match, capture) {
          return match.replace(/width=\"(.*)\"/gi, "");
        }
      );

      //去除text-indent
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/text-indent:[^;]+;/gi, "text-indent:0")
            .replace(/text-indent:[^;]+;/gi, "text-indent:0");
          return match;
        }
      );

      return newContent;
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    goUse() {
      this.$toast("暂未开放~");
    },
  },
};
</script>

<style lang="scss">
.car_guide_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
.car-guide {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
</style>

<style lang="scss" scoped>
.car-guide {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #2998ff;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;

  .header-b {
    padding: 16px;
    // background-color: #fff;
    img {
      height: 72px;
    }
  }

  .center-block {
    margin: 0 16px 10px;
    // height: 54px;
    background: #ffffff;
    border-radius: 10px;
    .top-block {
      height: 54px;
      //   background-color: green;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;

      .top-icon {
        width: 140px;
        height: 100%;

        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
          display: inline-block;
          width: 20px;
          height: 20px;
        }
        span {
          margin-left: 16px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
        }
      }

      .right-icon {
        width: 20px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          display: inline-block;
          width: 25px;
          height: 20px;
        }
      }
    }
    .foot-block {
      padding: 0 15px 15px;
      //   background-color: fuchsia;
      border-radius: 10px;
      transition: 3s;
      text-align: left;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
      img {
        display: block;
        width: 100%;
      }
      video {
        display: block;
        width: 100%;
      }
    }
  }

  .list {
    padding: 15px;
  }
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
</style>
